export default __webpack_public_path__ + "static/media/piggy-bank-wallet-and-coins.d9c5d97e.svg";